import { Component, OnInit } from "@angular/core";
import { Organisation } from "src/app/models/organisation";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder, Validators, UntypedFormControl } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
declare var $: any;
@Component({
  selector: "app-organisation-edit",
  templateUrl: "./organisation-edit.component.html",
  styleUrls: ["./organisation-edit.component.css"],
})
export class OrganisationEditComponent implements OnInit {
  editOrgCurrentTab: string = "personalInformation";
  editOrgListOfTabs: string[] = ["personalInformation"];

  organisation: Organisation = new Organisation();
  forms = {
    personalInformation: null,
  };
  states: any = [];
  ppfile: File = null;
  isEdited: Boolean = false;
  constructor(
    private service: VproService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.forms.personalInformation = this._formBuilder.group({
      oname: [null, [Validators.required]],
      address1: [null],
      address2: [null],
      org_id: [null],
      org_eid: [null, [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(Utils.emailpat),
      ]],
      city: [null],
      state: [null],
      zip: [null, [Validators.pattern(Utils.zipRegex), Validators.maxLength(6)]],
      contact_no: [null, [
        Validators.pattern(Utils.numberRegex),
        Validators.maxLength(12),
        Validators.minLength(10),
      ],
      ],
      opurl: [null],
      op_content_type: [null],
    });
  }

  ngOnInit() {
    this.loadStates();
    this.loadOrg();
  }

  loadStates(): any {
    this.spinner.show();
    this.service.getStates(1).subscribe((res) => {
      this.spinner.hide();
      this.states = res;
    });
  }

  loadOrg() {
    this.spinner.show();
    this.service
      .fetchOrganisationById(this.route.snapshot.params["id"])
      .subscribe(
        (response) => {
          this.spinner.hide();
          if (response) {
            this.organisation = response;
            this.forms.personalInformation.patchValue(this.organisation);
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  getControl(field: string): UntypedFormControl {
    return this.forms.personalInformation.get(field) as UntypedFormControl;
  }

  getStateName(state_id): any {
    //console.log(state_id);
    if (this.states && this.states.length > 0) {
      let state = this.states.filter(x => {
        return JSON.parse(x.id) === JSON.parse(state_id);
      });
      if (state && state.length > 0 && state[0].name) return state[0].name;
      return '';
    }
    return '';
  }

  updateField(field: string) {
    const control = this.getControl(field);
    // if (control.valid) {
    this.organisation = {
      ...this.organisation,
      [field]: control.value,
    };
    // }
  }

  /** Function to update Organisation data */
  public saveOrg(): void {
    // Create the JSON to be send to backend
    let data = {
      ...this.forms.personalInformation.value,
    };
    // Remove any empy fields
    data = Utils.removeNullAndEmpty(data);
    if (!this.isEdited) {
      delete data.opurl;
      delete data.op_content_type;
    }
    data["org_code"] = localStorage.getItem("orgcode");
    this.spinner.show();
    this.service
      .updateOrganisation(this.organisation.org_id, data, this.ppfile)
      .subscribe(
        (res) => {
          this.spinner.hide();
          // SweetAlert

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });

          Toast.fire({
            type: "success",
            title: "Organisation details has been updated successfuly",
          });
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  get f() {
    return this.forms[this.editOrgCurrentTab].controls;
  }

  public fileSelected(event) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (e: Event) => {
        // called once readAsDataURL is completed
        if (e && e.target && e.target["result"]) {
          this.organisation.opurl = e.target["result"];
        }
      };

      // now update opurl file to send in api
      this.ppfile = event.target.files[0];
      this.forms.personalInformation.patchValue({
        opurl: event.target.files[0].name,
        op_content_type: event.target.files[0].type,
      });

      this.isEdited = true;
    }
  }
}